import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * Represents the JSON used in the agent.config message sent to the speech service.
 */
export var AgentConfig = /*#__PURE__*/function () {
  function AgentConfig() {
    _classCallCheck(this, AgentConfig);
  }

  _createClass(AgentConfig, [{
    key: "toJsonString",
    value: function toJsonString() {
      return JSON.stringify(this.iPrivConfig);
    }
  }, {
    key: "get",
    value: function get() {
      return this.iPrivConfig;
    }
    /**
     * Setter for the agent.config object.
     * @param value a JSON serializable object.
     */

  }, {
    key: "set",
    value: function set(value) {
      this.iPrivConfig = value;
    }
  }]);

  return AgentConfig;
}();